/**
 * Rules for the accept-invitation form (Re-design T22). The API enforces 12–72 characters
 * (`AcceptInvitationDto`); the form mirrors exactly that and nothing stricter.
 */
export const ACCEPT_PASSWORD_MIN = 12;
export const ACCEPT_PASSWORD_MAX = 72;

export function acceptProblem(password: string, confirm: string): string | null {
  if (password.length < ACCEPT_PASSWORD_MIN) return `Password must be at least ${ACCEPT_PASSWORD_MIN} characters.`;
  if (password.length > ACCEPT_PASSWORD_MAX) return `Password must be at most ${ACCEPT_PASSWORD_MAX} characters.`;
  if (password !== confirm) return 'The two passwords do not match.';
  return null;
}
